import React, { useEffect, useState } from "react";
import api from "@/lib/appApi";
import { Sparkles } from "lucide-react";

export default function TrialBanner() {
  const [trial, setTrial] = useState(false);
  useEffect(() => {
    api.get("/config").then((r) => setTrial(!!r.data.trial_mode)).catch(() => {});
  }, []);
  if (!trial) return null;
  return (
    <div data-testid="trial-banner" className="w-full brand-gradient-bg text-white text-center text-xs sm:text-sm py-2 px-4 flex items-center justify-center gap-2 font-medium">
      <Sparkles className="w-4 h-4 shrink-0" />
      Free trial for a limited time — all Premium features are unlocked. Enjoy!
    </div>
  );
}
